var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column   section"},[_c('h1',{staticClass:"title"},[_vm._v("Login")]),_c('p',{staticClass:"is-size-5 has-text-danger"},[_c('git-footer')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }